import {
  InputAndLabelContainer,
  InputUnitLabel,
  LabledInput,
  MultipleInputRowContainer
} from './PanelComponents';

const HourMinuteSecondInput = ({ fieldId, values, errors, setValues }) => {
  const validateNumericalInput = value => {
    const parsedAsIntValue = parseInt(value);
    if (Number.isInteger(parsedAsIntValue) || value === '') {
      return true;
    }
  };

  const handleInputChange = (e, fieldId) => {
    const name = e.target.name;
    const value = e.target.value;
    const isValid = validateNumericalInput(value);
    if (!isValid) return;

    setValues(prevInputValues => ({
      ...prevInputValues,
      [fieldId]: {
        ...prevInputValues[fieldId],
        [name]: value
      }
    }));
  };
  return (
    <>
      {/* hours */}
      <MultipleInputRowContainer>
        <InputAndLabelContainer width="30%">
          <LabledInput
            type="number"
            name="hours"
            value={values.hours}
            onChange={e => handleInputChange(e, fieldId)}
            min="0"
            max="11929"
            isError={errors}
          />
          <InputUnitLabel>hrs</InputUnitLabel>
        </InputAndLabelContainer>
        {/* minutes */}
        <InputAndLabelContainer width="30%">
          <LabledInput
            type="number"
            name="minutes"
            value={values.minutes}
            onChange={e => handleInputChange(e, fieldId)}
            min="0"
            max="60"
            isError={errors}
          />
          <InputUnitLabel>min</InputUnitLabel>
        </InputAndLabelContainer>
        {/* seconds */}
        <InputAndLabelContainer width="30%">
          <LabledInput
            type="number"
            name="seconds"
            value={values.seconds}
            onChange={e => handleInputChange(e, fieldId)}
            min="0"
            max="60"
            isError={errors}
          />
          <InputUnitLabel>sec</InputUnitLabel>
        </InputAndLabelContainer>
      </MultipleInputRowContainer>
    </>
  );
};

export default HourMinuteSecondInput;
